/** Helpers for company phone: country dial code + exact 10-digit national number. */

export const DEFAULT_PHONE_DIAL_CODE = '+91';

export const parseStoredPhone = (phone, countryCodes = []) => {
  const raw = String(phone || '').trim();
  if (!raw) return { dialCode: DEFAULT_PHONE_DIAL_CODE, number: '' };

  const normalized = raw.startsWith('+') ? raw : /^\d/.test(raw) ? `+${raw}` : raw;
  const sorted = [...countryCodes].sort((a, b) => b.dialCode.length - a.dialCode.length);
  for (const entry of sorted) {
    if (normalized.startsWith(entry.dialCode)) {
      const number = normalized.slice(entry.dialCode.length).replace(/\D/g, '').slice(0, 10);
      return { dialCode: entry.dialCode, number };
    }
  }

  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) return { dialCode: DEFAULT_PHONE_DIAL_CODE, number: digits };
  if (digits.length > 10) {
    return { dialCode: DEFAULT_PHONE_DIAL_CODE, number: digits.slice(-10) };
  }
  return { dialCode: DEFAULT_PHONE_DIAL_CODE, number: digits };
};

export const composePhone = (dialCode, number) => {
  const digits = String(number || '').replace(/\D/g, '');
  if (!digits) return '';
  return `${dialCode || DEFAULT_PHONE_DIAL_CODE}${digits}`;
};

export const isExactTenDigitPhone = (number) => /^\d{10}$/.test(String(number || '').replace(/\D/g, ''));
